<template>
  <div class="container">
    <div class="row">
      <div class="col-md-16 col-md-offset-4">
        <form class="form-horizontal" @submit.prevent="submit" style="margin-top: 100px">
          <div class="text-center" style="margin-bottom: 20px">
            <img src="/img/logo.png">
          </div>

          <div class="panel panel-default panel-login">
            <div class="panel-body">
              <EmailFormGroup
                  v-model="data.email"
                  name="email"
                  label="Email"
                  :error="getError('email')"
              />

              <hr>

              <SubmitFormGroup :links="[{url: '/login', label: 'Back'}]">
                <button type="submit" class="btn btn-black">
                  <i class="fa fa-save"></i> Send Password Reset Link
                </button>
              </SubmitFormGroup>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {EmailFormGroup, SubmitFormGroup},

  mixins: [Errors],

  data() {
    return {
      data: {}
    }
  },

  methods: {
    submit() {
      axios.post('/api/v2/password-reset-links', this.data)
          .then(response => {
            notify.success('Password reset link sent')

            this.reset()
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.data = {}

      this.errors = {}
    }
  }
}
</script>
